import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { getSettings } from './api';
import Home from './pages/Home';
import Admin from './pages/Admin';
import './index.css';

export default function App() {
  const [settings, setSettings] = useState({
    site_title: 'El Popular',
    logo_url: '',
    logo_circular_url: '',
    logo_size: 52,
    color_header: '#b81623',
    color_bg: '#000000',
    color_footer: '#111111',
    color_titles: '#b81623',
    color_subtitles: '#a8a8a8',
    site_bio: 'Producción audiovisual · Creatividad sin límites',
    footer_text: '© El Popular. Todos los derechos reservados.'
  });

  const loadSettings = () => getSettings().then(s => setSettings({
    site_title: s.site_title || 'El Popular',
    logo_url: s.logo_url || '',
    logo_circular_url: s.logo_circular_url || '',
    logo_size: parseInt(s.logo_size) || 52,
    color_header: s.color_header || '#b81623',
    color_bg: s.color_bg || '#000000',
    color_footer: s.color_footer || '#111111',
    color_titles: s.color_titles || '#b81623',
    color_subtitles: s.color_subtitles || '#a8a8a8',
    site_bio: s.site_bio || 'Producción audiovisual · Creatividad sin límites',
    footer_text: s.footer_text || '© El Popular. Todos los derechos reservados.'
  })).catch(() => {});

  useEffect(() => { loadSettings(); }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--bg', settings.color_bg);
    root.style.setProperty('--color-header', settings.color_header);
    root.style.setProperty('--color-footer', settings.color_footer);
    root.style.setProperty('--color-titles', settings.color_titles);
    root.style.setProperty('--color-subtitles', settings.color_subtitles);
  }, [settings]);

  const logoStyle = {
    height: `${settings.logo_size}px`,
    width: 'auto',
    maxWidth: '800px',
    objectFit: 'contain',
    borderRadius: '0',
    border: 'none',
  };

  return (
    <BrowserRouter basename={window.__BASE_PATH__ || '/'}>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          {settings.logo_url
            ? <img src={settings.logo_url} alt="logo" style={logoStyle} />
            : <span style={{ color: 'var(--mustard)', fontStyle: 'italic', letterSpacing: 2 }}>{settings.site_title}</span>
          }
        </Link>
      </nav>
      <Routes>
        <Route path="/" element={<Home settings={settings} />} />
        <Route path="/369admin" element={<Admin onSettingsChange={loadSettings} />} />
      </Routes>
      <footer className="footer">
        <p>{settings.footer_text}</p>
      </footer>
    </BrowserRouter>
  );
}
